
import Spisi from '@/views/modules/cases_management/pages/Spisi.vue'
import FolderBlock from '@/views/modules/cases_management/pages/FolderBlock.vue'
import Posta from '@/views/modules/cases_management/pages/Posta.vue'
import Fakture from '@/views/modules/cases_management/pages/Fakture.vue'
import Sudionici from '@/views/modules/cases_management/pages/Sudionici.vue'
import Calendar from '@/views/modules/cases_management/pages/Calendar.vue'
import EnterNewCase from '@/views/modules/cases_management/forms/EnterNewCase.vue'
import EnterNewSpis from '@/views/modules/cases_management/forms/EnterNewSpis.vue'
import Cases from '@/views/modules/cases_management/pages/Cases.vue'
import Case from '@/views/modules/cases_management/pages/Case.vue'
import Troskovnik from '@/views/modules/cases_management/pages/Troskovnik.vue'
import Naplata from '@/views/modules/cases_management/pages/Naplata.vue'
import EnterNewPersonalEvent from '@/views/modules/general/forms/EnterNewPersonalEvent.vue'
import EnterNewEvent from '@/views/modules/general/forms/EnterNewEvent.vue'
import Planer from '@/views/modules/cases_management/pages/Planer.vue'
import TroskovnikReport from '@/views/modules/reports/TroskovnikReport.vue'
import TroskovnikReportEdit from '@/views/modules/admin_panel/pages/TroskovnikReportEdit.vue'

import { store } from "@/vuex/store.js"
import permissioner from '../../services/permissioner'
import predmeti from "@/apiCallers/promise_handler_db/predmeti"
import auth from "@/services/auth";

import NotPart from '@/views/modules/cases_management/pages/NotPart.vue'

// Returns the /archived-case/ equivalent path if the case is archived and we're on /case/
function getArchivedRedirectPath(to) {
  const caseData = store.state.current_selected_case;
  if (caseData && caseData.is_archived && to.path.startsWith('/case/')) {
    return to.fullPath.replace('/case/', '/archived-case/');
  }
  return null;
}

const regulateBeforeEnter = async (to, from, next) => {
  // Get user info if it is on reload
  console.log('[Route Guard] regulateBeforeEnter for case:', to.params.uid)
  await permissioner.checkUserInfo();
  let is_available = await getSingleUserPermissions(to.params.uid);

  // Load case data into Vuex BEFORE rendering component
  // This ensures App.vue has case data available when computing assistantMode
  if (is_available) {
    console.log('[Route Guard] Permissions OK, loading case data...');
    await getCaseData(to.params.uid);
    console.log('[Route Guard] Case data loaded:', store.state.current_selected_case ? 'SUCCESS' : 'FAILED');
    console.log('[Route Guard] Case ID in store:', store.state.current_selected_case && store.state.current_selected_case.group_url);

    // Redirect archived cases from /case/ to /archived-case/
    const archivedRedirect = getArchivedRedirectPath(to);
    if (archivedRedirect) {
      next(archivedRedirect);
      return;
    }

    next()
  } else {
    console.log('[Route Guard] No permissions, redirecting to NotPartOfCase');
    // Did  not satisfy the requirements for accessing the view
    next({ name: 'NotPartOfCase' })
  }
}

// Helper function to ensure case data is loaded before route navigation
const ensureCaseDataLoaded = async (caseId) => {
  await getCaseData(caseId);
}

var case_routes =
  [
    // All casses routes START
    {
      path: '/cases/',
      name: 'Cases',
      component: Cases,
      meta: { requiresAuth: true }
    },
    {
      path: '/archived-cases/',
      name: 'ArchivedCases',
      component: Cases,
      meta: { requiresAuth: true }
    },

    {
      path: '/case/:uid',
      name: 'Case',
      component: Case,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },

    {
      path: '/archived-case/:uid',
      name: 'ArchivedCase',
      component: Case,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },


    {
      path: '/archived-case/:uid/novi-spis',
      name: 'EnterNewSpis',
      component: EnterNewSpis,
      meta: { requiresAuth: true }
    },
    {
      path: '/archived-case/:uid/spisi/:broj_spisa/edit',
      name: 'EditExistingSpis',
      component: EnterNewSpis,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.spis.edit")) {
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/archived-case/" + to.params.uid)
        }
      }

    },
    {
      path: '/archived-case/:uid/kalendar/novi-dogadaj',
      name: 'EnterNewEvent',
      component: EnterNewEvent,
      meta: { requiresAuth: true }
    },
    {
      path: '/case/:uid/novi-spis',
      name: 'EnterNewSpis',
      component: EnterNewSpis,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        if (is_available) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          next({ name: 'NotPartOfCase' })
        }
      }
    },
    {
      path: '/case/:uid/troskovnik',
      name: 'Troskovnik',
      component: Troskovnik,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.payment.create")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },
    {
      path: '/case/:uid/naplata',
      name: 'Naplata',
      component: Naplata,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.payment.read")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },
    {
      path: '/archived-case/:uid/naplata',
      name: 'Naplata',
      component: Naplata,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.payment.read")) {
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/archived-case/" + to.params.uid)
        }
      }
    },
    {
      path: '/case/:uid/spisi/:broj_spisa/edit',
      name: 'EditExistingSpis',
      component: EnterNewSpis,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.spis.edit")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },
    {
      path: '/case/:uid/kalendar/novi-dogadaj',
      name: 'EnterNewEvent',
      component: EnterNewEvent,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.calendar.create")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },

    {
      path: '/case/:uid/kalendar/edit',
      name: 'EditCaseEvent',
      component: EnterNewEvent,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.calendar.edit")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },
    {
      path: '/archived-case/:uid/kalendar/edit',
      name: 'EditCaseEvent',
      component: EnterNewEvent,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.calendar.edit")) {
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/archived-case/" + to.params.uid)
        }
      }
    },
    {
      path: '/kalendar/novi-osobni-dogadaj/edit',
      name: 'EditPersonalEvent',
      component: EnterNewPersonalEvent,
      meta: { requiresAuth: true }
    },

    {
      path: '/novi-predmet/',
      name: 'EnterNewCase',
      component: EnterNewCase,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        // Checking if user has the right access to the application view
        if (await permissioner.check_application_permission("application.case.create")) {
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next({ name: 'NoPermission' })
        }
      }
    },
    {
      path: '/case/:uid/edit',
      name: 'EditExistingCase',
      component: EnterNewCase,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.edit")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },

    {
      path: '/case/:uid/spisi',
      name: 'Case',
      component: Spisi,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/spisi/:sid',
      name: 'Case',
      component: Spisi,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/radni',
      name: 'Radni',
      component: FolderBlock,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/popratni',
      name: 'Popratni',
      component: FolderBlock,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/posta',
      name: 'Posta',
      component: Posta,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/racuni',
      name: 'Racuni',
      component: Fakture,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/sudionici',
      name: 'Sudionici',
      component: Sudionici,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/troskovnik-report',
      name: 'TroskovnikReport',
      component: TroskovnikReport,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.payment.read")) {
          await getCaseData(to.params.uid);
          const archivedRedirect = getArchivedRedirectPath(to);
          if (archivedRedirect) { next(archivedRedirect); return; }
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/case/" + to.params.uid)
        }
      }
    },
    {
      path: '/archived-case/:uid/edit',
      name: 'EditExistingCase',
      component: EnterNewCase,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.edit")) {
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/archived-case/" + to.params.uid)
        }
      }
    },

    {
      path: '/archived-case/:uid/spisi',
      name: 'Case',
      component: Spisi,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/spisi/:sid',
      name: 'Case',
      component: Spisi,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/radni',
      name: 'Radni',
      component: FolderBlock,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/popratni',
      name: 'Popratni',
      component: FolderBlock,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/posta',
      name: 'Posta',
      component: Posta,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/sudionici',
      name: 'Sudionici',
      component: Sudionici,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/planer',
      name: 'CasePlaner',
      component: Planer,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/case/:uid/kalendar',
      name: 'Calendar',
      component: Calendar,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/planer',
      name: 'CasePlaner',
      component: Planer,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/kalendar',
      name: 'Calendar',
      component: Calendar,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/troskovnik-report-edit',
      name: 'TroskovnikReportEdit',
      component: TroskovnikReportEdit,
      meta: { requiresAuth: true },
      beforeEnter: regulateBeforeEnter
    },
    {
      path: '/archived-case/:uid/troskovnik-report',
      name: 'TroskovnikReport',
      component: TroskovnikReport,
      meta: { requiresAuth: true },
      beforeEnter: async (to, from, next) => {
        // Get user info if it is on reload
        await permissioner.checkUserInfo();
        let is_available = await getSingleUserPermissions(to.params.uid);
        // Checking if user has the right access to the application view
        if (is_available && permissioner.check_case_permsision("case.payment.read")) {
          next()
        } else {
          // Did  not satisfy the requirements for accessing the view
          next("/archived-case/" + to.params.uid)
        }
      }
    },
    {
      path: '/case-not-part',
      name: 'NotPartOfCase',
      component: NotPart,
      meta: { requiresAuth: true }
    },
  ]

var getSingleUserPermissions = async function (case_id) {
  // 1. Check if state is empty or case id is same as mapped
  // if empty get data
  if (store.state.mapped_case_permission == undefined) {
    await predmeti.getUserCasePermissions(case_id, store.state.logged_in_user.uid).then((resp) => {
      permissioner.save_case_permission(case_id, resp.data);
    })
  }
  else if (store.state.mapped_case_permission.case_id != case_id) {
    await predmeti.getUserCasePermissions(case_id, store.state.logged_in_user.uid).then((resp) => {
      permissioner.save_case_permission(case_id, resp.data);
    })
  }
  // 2. Check the value when we have data
  // if not return true
  if (store.state.mapped_case_permission.available_permissions.length > 0 || store.state.logged_in_user.user_role.id == 1 || store.state.logged_in_user.user_role.id == 9)
    return true
  // if empty return false
  else return false;

}
const getCaseData = async function (case_id) {
  console.log('[getCaseData] Called for case_id:', case_id);
  console.log('[getCaseData] Current case in store:', store.state.current_selected_case && store.state.current_selected_case.group_url);

  // check for stored case data
  const accessToken = store.state.aToken

  if (store.state.current_selected_case == undefined || store.state.current_selected_case == null) {
    console.log('[getCaseData] No case data in store, fetching from API...');
    await predmeti.getSingle(case_id, store.state.logged_in_user.uid).then(async (response) => {
      console.log('[getCaseData] API response received, setting case data via mutation');
      store.commit('SET_CURRENT_CASE', response.data.all_info_predmet.predmet_info);
      console.log('[getCaseData] Case data set:', store.state.current_selected_case.group_url);
    });
  } else if (store.state.current_selected_case.group_url != case_id) {
    console.log('[getCaseData] Different case in store, fetching new case from API...');
    await predmeti.getSingle(case_id, store.state.logged_in_user.uid).then(async (response) => {
      console.log('[getCaseData] API response received, setting case data via mutation');
      store.commit('SET_CURRENT_CASE', response.data.all_info_predmet.predmet_info);
      console.log('[getCaseData] Case data set:', store.state.current_selected_case.group_url);
    });
  } else {
    console.log('[getCaseData] Case data already in store, reusing');
  }

  // return the case data if propperly selected
  console.log('[getCaseData] Returning case data:', store.state.current_selected_case && store.state.current_selected_case.group_url);
  return store.state.current_selected_case;
}

const clearCaseData = async function () {
  store.commit('CLEAR_CURRENT_CASE');
  store.state.mapped_case_permission = undefined
}



export { case_routes, getCaseData, clearCaseData }